export const contextAddMenuPaperSx = {
  width: { xs: 'min(calc(100vw - 24px), 340px)', sm: 340 },
  maxWidth: 'calc(100vw - 24px)',
  mt: 0.75,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
  boxShadow: '0 12px 28px rgba(15, 23, 42, 0.14)',
  overflow: 'hidden',
};

export const contextAddMenuListSx = { p: 0.5 };

export const contextAddMenuHeaderSx = {
  px: 1.25,
  py: 0.75,
};

export const contextAddMenuHeaderLabelSx = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  color: '#475569',
  letterSpacing: 0,
};

export const contextAddMenuItemSx = {
  py: 1,
  px: 1.25,
  gap: 1,
  alignItems: 'center',
  borderRadius: 1,
  whiteSpace: 'normal',
  '&:hover': { bgcolor: 'action.hover' },
};

export const contextAddMenuItemIconSx = { minWidth: 28, color: '#475569' };

export const contextAddMenuItemPrimaryTypographyProps = { fontSize: '0.875rem', fontWeight: 600, color: 'text.primary', letterSpacing: 0 };

export const contextAddMenuItemSecondaryTypographyProps = { fontSize: '0.75rem', lineHeight: 1.4, color: 'text.secondary' };
